import { useNavigate } from 'react-router-dom';
import { Truck } from 'lucide-react';
import StatusBadge from './StatusBadge';

// Displays a single load as a tappable card in the Loads list.
// Shows the DRIVER's own price (their computed cut based on their
// default_rate) — never the real load price, which only
// dispatchers/admins see in the admin app.
function LoadCard({ load }) {
  const navigate = useNavigate();

  const {
    id_load,
    origin,
    destination,
    vehicle_name,
    vehicle_model,
    load_status,
    driver_price,
    price_currency,
  } = load;

  return (
    <div onClick={() => navigate(`/loads/${id_load}`)} style={styles.card}>
      <div style={styles.thumbnailPlaceholder}>
        <Truck size={28} color="#9ca3af" />
      </div>

      <div style={styles.info}>
        <div style={styles.topRow}>
          <span style={styles.vehicleName}>
            {vehicle_name} {vehicle_model}
          </span>
          <StatusBadge status={load_status} />
        </div>

        <div style={styles.routeRow}>
          <span style={styles.routeText}>{origin}</span>
          <span style={styles.arrow}>→</span>
          <span style={styles.routeText}>{destination}</span>
        </div>

        {driver_price != null && (
          <div style={styles.priceRow}>
            <span style={styles.priceText}>
              {Number(driver_price).toLocaleString()} {price_currency}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  card: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 12,
    padding: 12,
    marginBottom: 12,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    cursor: 'pointer',
  },
  thumbnailPlaceholder: {
    width: 64,
    height: 64,
    borderRadius: 10,
    backgroundColor: '#f3f4f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
    flexShrink: 0,
  },
  info: {
    flex: 1,
    minWidth: 0,
  },
  topRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  vehicleName: {
    fontWeight: 700,
    fontSize: 15,
    color: '#111827',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  routeRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 4,
  },
  routeText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 600,
    color: '#374151',
    fontSize: 13,
  },
  arrow: {
    margin: '0 6px',
    color: '#9ca3af',
  },
  priceRow: {
    marginTop: 2,
  },
  priceText: {
    fontSize: 14,
    fontWeight: 700,
    color: '#2563eb',
  },
};

export default LoadCard;